import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import FhirLoader from '../../../../FhirLoader'
import { AllergyIntoleranceBundle } from '../../../../../types/FHIRTypes/Bundle'
import { AllergyIntoleranceTable } from '@teschglobal/tg-fhir-react-components'
import { isAllergyIntoleranceBundle } from '../../../../../typeGuards/fhirTypes'

type AllergyListProps = {
    allergyData?: AllergyIntoleranceBundle;
    isFetching: boolean;
    handleChangePage: (page: number) => void
    totalPages: number;
    currentPage: number;
}

const AllergyList: FC<AllergyListProps> = ({ allergyData, handleChangePage, isFetching, totalPages, currentPage }) => {
    if (!isAllergyIntoleranceBundle(allergyData)) return null

    const patientAllergies = allergyData && allergyData.entry ? allergyData.entry.map((allergy) => allergy.resource) : []

    if (isFetching) {
        return <FhirLoader message='Loading...' />
    }

    return (
        <>
            {
                allergyData.total > 0 && (
                    <div className='my-3 fw-bold'>
                        <span role="status" aria-live="polite">{allergyData.total.toLocaleString()} record(s) found</span>
                        <PaginationButtons
                            totalPages={totalPages}
                            currentPage={currentPage}
                            handleChangePage={handleChangePage}
                        />
                    </div>
                )
            }
            <AllergyIntoleranceTable
                allergyIntolerances={patientAllergies}
            />
            {
                allergyData.total > 0 && (
                    <div className='my-3 fw-bold'>
                        <PaginationButtons
                            totalPages={totalPages}
                            currentPage={currentPage}
                            handleChangePage={handleChangePage}
                        />
                    </div>
                )
            }
        </>
    )
}

export default AllergyList